import { createSelector } from "reselect";
import { IModelModuleState, IModelState } from "./reducer";

export function selectModelState(state: IModelModuleState): IModelState {
    return state.modelState;
}
export const selectSensorToAdd = createSelector(selectModelState, state => state.sensorToAdd);
export const selectGeometryToAdd = createSelector(selectModelState, state => state.geometryToAdd);
export const selectUsedItemsInAssembly = createSelector(selectModelState, state => state.usedItemsInAssembly);
